import {useAuth} from 'context/authContext';
import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {signUp} from 'services/auth';
import normalizeLoginResponse from 'utilities/helper/normalizeLoginResponse/normalizeLoginResponse';

const UseSignUp = () => {
  const navigate = useNavigate();
  const {login} = useAuth();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: ISignUpPayload) => {
      return signUp(payload);
    },
    onSuccess: (data, variables) => {
      login(normalizeLoginResponse(data, 'market')!);
      navigate('/wholesaler/home');
    },
  });

  return {isLoading, mutate};
};

export default UseSignUp;
